import React, { memo, useCallback } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { PROPERTY_TAB_KEYS } from '../../../common/propertyDetailTypes'
import { propertyDetailPath } from '../../utils/paths'
import { useSetPropertyDrawer } from '../../utils/useSetPropertyDrawer'

export interface PropertyDrawerLinkProps {
  propertyId: string
  propertyType: PROPERTY_TYPES
  children?: React.ReactNode
  tab?: PROPERTY_TAB_KEYS
  className?: string
  title?: string
  emptyPlaceholder?: React.ReactNode
  emptyTitle?: string
  onDrawerOpen?: () => void
}

export const PropertyDrawerLink: React.FC<PropertyDrawerLinkProps> = memo(
  ({
    propertyId,
    propertyType,
    children,
    tab,
    className,
    title = 'Zobrazit detail nemovitosti',
    emptyPlaceholder = '---',
    emptyTitle = 'Hodnota není evidována',
    onDrawerOpen,
  }) => {
    const setDrawer = useSetPropertyDrawer()

    const isEmpty =
      children === null ||
      children === undefined ||
      (typeof children === 'string' && children.trim() === '')

    const handleClick = useCallback(
      (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
          e.preventDefault()
          setDrawer(propertyId, propertyType)
          onDrawerOpen?.()
        }
      },
      [propertyId, propertyType, onDrawerOpen, setDrawer]
    )

    if (isEmpty) {
      return (
        <span
          className={['text-gray-400', className].filter(Boolean).join(' ')}
          title={emptyTitle}
        >
          {emptyPlaceholder}
        </span>
      )
    }

    return (
      <a
        href={propertyDetailPath(propertyType, propertyId, tab)}
        onClick={handleClick}
        className={className}
        title={title}
      >
        {children}
      </a>
    )
  }
)
